import React from 'react'

function MechanismPanel ({item}) {
    return (
        <div className="mechanismPanel lx-bg-color-white lx-hidden">
            <div className="panel-title lx-fz16 lx-mb5 lx-fwBold">{ item.title }</div>
            <div className="panel-content lx-fz14 lx-text-color-secondary lx-mb15" dangerouslySetInnerHTML={{__html: "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" + item.content }}>
            </div>
            {/* <div className="panel-btn lx-flex-row-center lx-fz18 lx-text-color-white">
                立即投递
            </div> */}
            <a href={item.toUrl} className="panel-btn lx-flex-row-center lx-fz18 lx-text-color-white" rel="noreferrer">立即投递</a>
        </div>
    ) 
}

export default MechanismPanel;